import { Button } from '@bfe/moly';
import { GoogleIcon } from '@bfe/moly-icons';
import { FC, useEffect, useState } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';
import { useI18nContext } from '@/i18n/I18n';
import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useSecuritySettingModalData } from '@/store/useSecuritySettingModal/useSecuritySettingModalData';
import { useStore } from '@/store/useStore';

const GoogleAuth: FC = () => {
  const [$t] = useI18nContext();
  const { userInfo: user } = useStore();

  const { openSecuritySettingModal } = useSecuritySettingModal();
  const { checkGoogleUnderReview, gaIsUnderReview, gaUnbinding } =
    useSecuritySettingModalData();

  useEffect(() => {
    checkGoogleUnderReview();
  }, [user.id]);

  const openGoogleAuthModal = () => {
    window.location.hash = '';
    openSecuritySettingModal(SecuritySettingModalNames.Ga);
  };

  useEffect(() => {
    const openGaBind = window.location.hash === '#openGaBind';
    if (openGaBind) {
      openGoogleAuthModal();
    }
  }, [user, gaIsUnderReview]);

  const GoogleOperation = ({ loading }: { loading: boolean }) => {
    if (!user.has_google2fa) {
      // 2fa
      return (
        <Button
          size="small"
          data-radius="small"
          variant="primary"
          onClick={openGoogleAuthModal}
        >
          {$t('Setting')}
        </Button>
      );
    } else if (gaIsUnderReview) {
      // has_google2fa 并且 审核中

      // 是否可以解绑
      return (
        <Button size="small" data-radius="small" variant="secondary" disabled>
          {$t('UnderReview')}
        </Button>
      );
    } else {
      // 禁用
      return (
        <Button
          size="small"
          data-radius="small"
          variant="secondary"
          onClick={openGoogleAuthModal}
          loading={loading}
        >
          {$t('Disable')}
        </Button>
      );
    }
  };

  return (
    <>
      <AccountBasicItem
        icon="google2fa"
        molyIcon={<GoogleIcon />}
        text={$t('Google Authentication')}
        subText={$t(
          'For Login, Withdraw, password retrieval, security settings change and API management verification',
        )}
        status={user.has_google2fa}
        statusNode={
          <>
            {user.has_google2fa ? (
              <span>{$t('Set up')}</span>
            ) : (
              <span className="not-set-text">{$t('Not Set')}</span>
            )}
          </>
        }
        operation={
          <>
            <GoogleOperation loading={gaUnbinding} />
          </>
        }
      />
    </>
  );
};
export default GoogleAuth;
